import { atom } from "recoil";

export type CropZoomSelection = {
    originalUrl?: string;
    originalSize?: { width: number; height: number };
    onResolve?: (newUrl?: string) => void;
};

export const cropZoomSelectionAtom = atom<CropZoomSelection | undefined>({
    key: "cropZoomSelection",
    default: undefined,
});
